import { trackRSFilterClicked } from '@app/analytics';
import Box from '@redbubble/design-system/src/Box';
import List from '@redbubble/design-system/src/List';
import Text from '@redbubble/design-system/src/Text';
import {
  RSFilterClickedLocation,
  useRudderstackClient,
} from '@redbubble/next-provider/rudderstack';
import { kebabCase } from 'lodash';
import { ProductStyleSelectorItem } from './ProductStyleSelectorItem';
import styles from './ProductStyleSwitcher.module.scss';
import type { ProductStyleData } from './useProductSwitchData';

export interface ProductStylesListProps {
  currentProductTypeId: string;
  currentProductTypeGACode: string;
  productStyles: ProductStyleData[];
  title?: string;
}

export const ProductStylesList = ({
  currentProductTypeId,
  currentProductTypeGACode,
  productStyles,
  title,
}: ProductStylesListProps) => {
  const titleId = title
    ? `product-styles-list-${kebabCase(title.toLowerCase())}`
    : '';

  const { RudderstackClient } = useRudderstackClient();

  return (
    <>
      {title && (
        <Box marginBottom="xxs">
          <Text className={styles.listTitle} type="display5" id={titleId}>
            {title}
          </Text>
        </Box>
      )}
      <List aria-labelledby={titleId}>
        {productStyles.map((style) => {
          if (!style.productPageUrl) {
            return null;
          }

          const active = style.productTypeId === currentProductTypeId;

          const handleClick = () => {
            if (active) return;
            trackRSFilterClicked({
              rsClient: RudderstackClient,
              filterLabel: style.description,
              location: RSFilterClickedLocation.PdpStyleSelector,
            });
          };

          return (
            <ProductStyleSelectorItem
              key={style.productTypeId}
              active={active}
              description={style.description}
              longDescription={style.longDescription}
              previewImageUrl={style.previewImageUrl}
              matureContent={style.matureContent}
              descriptionTextType="display6"
              longDescriptionTextType="caption"
              price={style.price}
              productPageUrl={style.productPageUrl}
              onClick={handleClick}
            />
          );
        })}
      </List>
    </>
  );
};
